import { useGetUserDetailsQuery } from 'store/apis/userDetailsApi';
import { useDispatch, useSelector } from 'react-redux';
import { algoliaUserSlidesSearchApiKeySelector } from 'store/slices/userDetailsSlice';
import { MiniDrawerWithContext } from 'components/Layout/drawer';
import { PathologyMapMainContent } from 'components/PathologyMap/PathologyMapMainContent';
import { SLIDES_SEARCH_V2_NAME } from 'components/PathologyMap/constants/common';
import { useTitle } from 'components/utilities/hooks/useTitle';
import { useEffect } from 'react';
import { setViewedSlideCards } from 'store/slices/pathologyMapSlice';

export const UserSlidesPathologyMapPage = () => {
  const dispatch = useDispatch();
  const algoliaSearchApiKey = useSelector(
    algoliaUserSlidesSearchApiKeySelector,
  );
  useTitle(SLIDES_SEARCH_V2_NAME);
  // need to update user details cause otherwise there is a chance to pull stale teams data
  const { refetch } = useGetUserDetailsQuery();

  useEffect(() => {
    refetch();

    return () => {
      dispatch(setViewedSlideCards([]));
    };
  }, []);

  return (
    <MiniDrawerWithContext
      header={SLIDES_SEARCH_V2_NAME}
      isWithInfiniteScrollPage
    >
      <PathologyMapMainContent algoliaSearchApiKey={algoliaSearchApiKey} />
    </MiniDrawerWithContext>
  );
};
